import { Link } from 'react-router-dom';
import { SEOHead } from '@/components/layout/SEOHead';
import { FadeIn } from '@/components/motion/FadeIn';
import { getAllJournalPosts } from '@/lib/content';

function formatDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric',
    });
  } catch { return iso; }
}

export function JournalPage() {
  const posts = getAllJournalPosts();

  return (
    <>
      <SEOHead
        title="Journal · Brian Ellison Design"
        description="Writings on craft, materials, and the practice of interior design."
        canonical="https://brianellisondesign.com/journal"
        ogImage="/posters/og-journal.jpg"
      />
      <section className="page-hero">
        <div className="container">
          <FadeIn>
            <p className="eyebrow">Journal</p>
            <h1 className="page-hero__title">Notes from the studio.</h1>
            <p className="subtitle">
              Thoughts on craft, materials, projects in progress, and the work itself.
            </p>
          </FadeIn>
        </div>
      </section>
      <section className="container section">
        <ul className="journal-list">
          {posts.map((post, i) => (
            <FadeIn key={post.slug} as="li" delay={i * 60}>
              <Link to={`/journal/${post.slug}`} className="journal-list__entry">
                <p className="eyebrow">{formatDate(post.date)}{post.category ? ` · ${post.category}` : ''}</p>
                <h2 className="journal-list__title">{post.title}</h2>
                <p className="journal-list__excerpt">{post.excerpt}</p>
              </Link>
            </FadeIn>
          ))}
        </ul>
        {posts.length === 0 ? (
          <p className="caption">Journal entries forthcoming.</p>
        ) : null}
      </section>
    </>
  );
}
